<div class="dialog-content">
  <!-- External Drop Zone -->
  <div [kendoUploadDropZone]="dropZoneId()" class="dropzone">
    Drag & drop files here
    <span class="hint">or use the button below</span>
  </div>

  <!-- Kendo Upload -->
  <kendo-upload
    [zoneId]="dropZoneId()"
    [saveUrl]="'noop'"
    [autoUpload]="false"
    [multiple]="false"
    [withCredentials]="false"
    [restrictions]="restrictions"
    [(ngModel)]="files"
    (upload)="onUpload($event)"
  >
  </kendo-upload>
  <div id="upload-progress">{{ progress() / 100 }}% / 100%</div>
</div>

<footer class="k-d-flex k-justify-content-between">
  <button (click)="close()" kendoButton size="large" themeColor="secondary" class="k-mr-4 !k-pr-4">
    <span class="custom-symbol close k-mr-3"></span>
    <span class="label">Schließen</span>
  </button>

  <button kendoButton class="!k-pr-4" themeColor="base" size="large">
    <fa-icon [icon]="faUpload" class="add k-text-white k-mr-3"></fa-icon>
    <span class="label">Profilbild wechseln</span>
  </button>
</footer>
